/* ECOM VENOM — conversion motion layer: counters, price drop, offer countdown. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = (n) => Math.round(n).toLocaleString('en-US');
  const num = (t) => { const m = String(t).replace(/,/g, '').match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : NaN; };
  const ease = (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t));

  // Animate the last digit-bearing text node inside el from `from` to `to`.
  const textNodeOf = (el) => {
    const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    let last = null;
    while (w.nextNode()) if (/\d/.test(w.currentNode.nodeValue) && !w.currentNode.parentElement.closest('.ev-visually-hidden')) last = w.currentNode;
    return last;
  };
  const count = (el, from, to, ms = 1500, done) => {
    const node = textNodeOf(el);
    if (!node || !isFinite(from) || !isFinite(to)) return done && done();
    const tpl = node.nodeValue;
    const put = (v) => { node.nodeValue = tpl.replace(/[\d,]+(?:\.\d+)?/, fmt(v)); };
    if (reduce || from === to) { put(to); return done && done(); }
    const t0 = performance.now();
    put(from);
    const step = (now) => {
      const p = Math.min(1, (now - t0) / ms);
      put(from + (to - from) * ease(p));
      if (p < 1) requestAnimationFrame(step); else { put(to); done && done(); }
    };
    requestAnimationFrame(step);
  };

  const onView = (els, fn, margin = '0px 0px -12% 0px') => {
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) return els.forEach(fn);
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (en.isIntersecting) { io.unobserve(en.target); fn(en.target); }
    }), { rootMargin: margin });
    els.forEach((el) => io.observe(el));
  };

  const init = () => {
    // 1) Price chips in CTAs: compare-at → live price.
    onView([...document.querySelectorAll('[data-ev-count]')], (el) => {
      count(el, parseFloat(el.dataset.from), parseFloat(el.dataset.to), 1600, () => { el.classList.add('is-done'); });
    }, '0px');

    // 2) Big prices: strike draws, offer counts down from the base, discount badge pops.
    const prices = [...document.querySelectorAll('.vx-offer .ev-price, .vx-final .ev-price, .vx-value__total .ev-price, .vr-product-buy .ev-price, .ev-product .ev-price--mega')];
    prices.forEach((p) => {
      const base = p.querySelector('.ev-price__base');
      const offer = p.querySelector('.ev-price__offer');
      if (!base || !offer) return;
      const b = num(textNodeOf(base)?.nodeValue), o = num(textNodeOf(offer)?.nodeValue);
      if (!(b > o)) return;
      p.classList.add('is-drop');
      if (!p.nextElementSibling || !p.nextElementSibling.classList.contains('ev-off-badge')) {
        const badge = document.createElement('span');
        badge.className = 'ev-off-badge';
        badge.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2v8M2.5 6.5 6 10l3.5-3.5"/></svg>خصم <bdi dir="ltr">' + Math.round((b - o) / b * 100) + '%</bdi>';
        p.insertAdjacentElement('afterend', badge);
      }
      p._ev = { b, o, offer };
    });
    onView(prices.filter((p) => p._ev), (p) => {
      p.classList.add('is-run');
      count(p._ev.offer, p._ev.b, p._ev.o, 1700);
    });

    // 3) Fact numbers count up (e.g. 30 lectures).
    const facts = [...document.querySelectorAll('.vx-system__facts strong, .vx-signals__k')].filter((el) => {
      const t = textNodeOf(el); if (!t || /(^|\D)0\d/.test(t.nodeValue)) return false;
      const n = num(t.nodeValue); return isFinite(n) && n > 0 && n < 10000;
    });
    onView(facts, (el) => { const n = num(textNodeOf(el).nodeValue); count(el, 0, n, 1200); });

    // 4) Offer countdown (fixed end date, or rolls over daily at local midnight).
    const timers = [...document.querySelectorAll('[data-ev-timer]')];
    if (timers.length) {
      const endOf = (el) => {
        const raw = (el.dataset.end || '').trim();
        if (raw) { const d = new Date(raw.replace(' ', 'T')); if (!isNaN(d)) return d; }
        const m = new Date(); m.setHours(24, 0, 0, 0); return m;
      };
      const pad = (n) => String(n).padStart(2, '0');
      const state = timers.map((el) => ({ el, end: endOf(el), fixed: !!(el.dataset.end || '').trim(), parts: { h: el.querySelector('[data-ev-t="h"]'), m: el.querySelector('[data-ev-t="m"]'), s: el.querySelector('[data-ev-t="s"]') } }));
      const tick = () => {
        const now = Date.now();
        state.forEach((st) => {
          let left = st.end - now;
          if (left <= 0) {
            if (st.fixed) { left = 0; }
            else { const m = new Date(); m.setHours(24, 0, 0, 0); st.end = m; left = st.end - now; }
          }
          const s = Math.floor(left / 1000);
          const v = { h: pad(Math.floor(s / 3600)), m: pad(Math.floor(s / 60) % 60), s: pad(s % 60) };
          Object.keys(v).forEach((k) => {
            const node = st.parts[k];
            if (node && node.textContent !== v[k]) {
              node.textContent = v[k];
              if (!reduce) { node.classList.remove('is-tick'); void node.offsetWidth; node.classList.add('is-tick'); }
            }
          });
        });
      };
      tick();
      setInterval(tick, 1000);
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
